module.exports = __webpack_public_path__ + "img/shakhtar.c1c3ef36.png";